import {GrowthBookReady} from 'components/GrowthBookReady/GrowthBookReady';
import React, {lazy, Suspense, useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';
import LoadingScreen from 'screens/LoadingScreen/LoadingScreen';
import {usePageTracking} from './usePageTracking';
import {QABar} from 'components/QATools/QABar';
import Analytics from 'utils/Analytics';
import {prefersDarkMode} from 'utils/darkMode';
import {BookAppointmentRoutes} from './BookAppointmentRoutes';
import {InsomniaRoutes} from './InsomniaRoutes';
import {OsaRoutes} from './OsaRoutes';

const QARoutes = lazy(() => import('./QARoutes'));

const AppRoutes: React.FC = () => {
  usePageTracking();

  useEffect(() => {
    Analytics.identify({
      dark_mode: prefersDarkMode() ? 'enabled' : 'disabled',
    });
  }, []);

  return (
    <Suspense fallback={<div />}>
      <GrowthBookReady
        requiredGBAttributes={['web_funnel_anon_id']}
        timeout={3000}
        fallback={<LoadingScreen delay={500} />}
      >
        <QABar />
        <Routes>
          <Route path="/devqatools/*" element={<QARoutes />} />
          <Route path="/osa/*" element={<OsaRoutes />} />
          <Route path="/book-appointment/*" element={<BookAppointmentRoutes />} />
          <Route path="/*" element={<InsomniaRoutes />} />
        </Routes>
      </GrowthBookReady>
    </Suspense>
  );
};

export default AppRoutes;
